import { Injectable } from '@angular/core';
import { concatMap, from, Observable } from 'rxjs';
import { IbdSdkService } from '../common/ibd-sdk.service';
import { AssetManagement } from '@ct-asm/asm-asset-management-typescript-sdk/dist/src/AssetManagement';
import { StorageService } from '../storage/storage.service';
import { Configuration } from '@ct-asm/asm-asset-management-typescript-sdk/dist/src/configuration/configuration';
import { environment } from 'src/environments/environment';
import { ConfigurationDataReturnType } from '@ct-asm/asm-asset-management-typescript-sdk/dist/src/configuration/configuration_data_and_types';
import { CrimpCloudPartnerDeleteResponse, CrimpCloudPartnerResponse } from '@ct-asm/asm-asset-management-typescript-sdk/dist/src/crimp-cloud-partners/crimp_cloud_partners_response';
import { CrimpCloudPartner, CrimpCloudPartnerDeleteReq, CrimpCloudPartnerListRequest, CrimpCloudPartnerRequest } from '@ct-asm/asm-asset-management-typescript-sdk/dist/src/crimp-cloud-partners/crimp_cloud_partner_request';

@Injectable({
  providedIn: 'root'
})
export class CrimpCloudPartnerService {
  asm: AssetManagement;
  config: ConfigurationDataReturnType;

  constructor(
    public store: StorageService,
    public ibdSdkService: IbdSdkService
  ) {
    this.config = new Configuration(
      environment.cmsSettings.appClientId,
      environment.name
    ).load();
    this.asm = new AssetManagement(this.store, this.config);
  }

  listCrimpCloudPartners(partnerListParams: CrimpCloudPartnerListRequest): Observable<CrimpCloudPartnerResponse[] | null> {
    return from(this.ibdSdkService.loginCheck()).pipe(
      concatMap(() =>
        from(this.asm.crimpCloudPartnerManager.listCrimpCloudPartners(partnerListParams))
      )
    );
  }

  createCrimpCloudPartners(partnerData: CrimpCloudPartner): Observable<CrimpCloudPartnerResponse[] | null> {
    const partnerCreateRequest = new CrimpCloudPartnerRequest(partnerData);

    return from(this.ibdSdkService.loginCheck()).pipe(
      concatMap(() =>
        from(this.asm.crimpCloudPartnerManager.createCrimpCloudPartners(partnerCreateRequest))
      )
    );
  }

  deleteCrimpCloudPartner(deleteReqParams: CrimpCloudPartnerDeleteReq): Observable<CrimpCloudPartnerDeleteResponse | null> {
    return from(this.ibdSdkService.loginCheck()).pipe(
      concatMap(() =>
        from(this.asm.crimpCloudPartnerManager.deleteCrimpCloudPartners(deleteReqParams))
      )
    );
  }

}

